var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartLarge2SvgrepoCom5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.75L2.83114 3.86037C4.48119 4.4104 5.30621 4.6854 5.7781 5.34012C6.25 5.99484 6.25 6.86449 6.25 8.6038V11.875C6.25 15.4105 6.25 17.1782 7.34835 18.2766C8.4467 19.375 10.2145 19.375 13.75 19.375H23.75",
    stroke: "#2D3B36",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.375 22.5C10.4105 22.5 11.25 23.3395 11.25 24.375C11.25 25.4105 10.4105 26.25 9.375 26.25C8.33946 26.25 7.5 25.4105 7.5 24.375C7.5 23.3395 8.33946 22.5 9.375 22.5Z",
    stroke: "#2D3B36",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.625 22.5C21.6605 22.5 22.5 23.3394 22.5 24.375C22.5 25.4105 21.6605 26.25 20.625 26.25C19.5895 26.25 18.75 25.4105 18.75 24.375C18.75 23.3394 19.5895 22.5 20.625 22.5Z",
    stroke: "#2D3B36",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.5H20.563C23.1317 7.5 24.416 7.5 24.9719 8.34283C25.5276 9.18566 25.0216 10.3662 24.0097 12.7272L23.474 13.9772C23.0016 15.0795 22.7654 15.6306 22.2957 15.9404C21.8261 16.25 21.2265 16.25 20.0272 16.25H6.25",
    stroke: "#2D3B36",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLarge2SvgrepoCom5);
export default __webpack_public_path__ + "static/media/cart-large-2-svgrepo-com 5.91f04afb6c43e12e07bfb2a604f590c9.svg";
export { ForwardRef as ReactComponent };